var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.62 33.8993C21.24 33.8993 20.86 33.7593 20.56 33.4593L17.56 30.4593C16.98 29.8793 16.98 28.9193 17.56 28.3393C18.14 27.7593 19.1 27.7593 19.68 28.3393L21.62 30.2793L28.56 23.3393C29.14 22.7593 30.1 22.7593 30.68 23.3393C31.26 23.9193 31.26 24.8793 30.68 25.4593L22.68 33.4593C22.4 33.7593 22 33.8993 21.62 33.8993Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13.5H20C18.08 13.5 14.5 13.5 14.5 8C14.5 2.5 18.08 2.5 20 2.5H28C29.92 2.5 33.5 2.5 33.5 8C33.5 9.92 33.5 13.5 28 13.5ZM20 5.5C18.02 5.5 17.5 5.5 17.5 8C17.5 10.5 18.02 10.5 20 10.5H28C30.5 10.5 30.5 9.98 30.5 8C30.5 5.5 29.98 5.5 28 5.5H20Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45.5008H18C6.76 45.5008 4.5 40.3408 4.5 32.0008V20.0008C4.5 10.8808 7.8 6.98084 15.92 6.56084C16.74 6.52084 17.46 7.14084 17.5 7.98084C17.54 8.82084 16.9 9.50084 16.08 9.54084C10.4 9.86084 7.5 11.5608 7.5 20.0008V32.0008C7.5 39.4008 8.96 42.5008 18 42.5008H30C39.04 42.5008 40.5 39.4008 40.5 32.0008V20.0008C40.5 11.5608 37.6 9.86084 31.92 9.54084C31.1 9.50084 30.46 8.78084 30.5 7.96084C30.54 7.14084 31.24 6.50084 32.08 6.54084C40.2 6.98084 43.5 10.8808 43.5 19.9808V31.9808C43.5 40.3408 41.24 45.5008 30 45.5008Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardTick);
export default __webpack_public_path__ + "static/media/ClipboardTick.9ba1c838.svg";
export { ForwardRef as ReactComponent };